import React, {useEffect, useState} from "react";
import Main from './MainComponent';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/App.css';
import '../css/Textures.css';
import '../css/AllControls.css';
import '../css/LoadingCircles.css';
import '../css/Models.css';
import '../css/ComponentSlider.css';

import { withTranslation } from 'react-i18next';
import { I18nextProvider } from 'react-i18next';
import { useTranslation } from 'react-i18next';

function App() {
    const {i18n} = useTranslation('common');
    const [models, setModels] = useState([]);

    useEffect( () => {
        /*
        * it's not possible to import models.json from public folder
        * so we have to load it via fetch
        * */
        const loadModelsJSON = async () => {
            let response = await fetch('json/models.json');
            //let response = await fetch('https://test.ddn.ua/3dmodel/json/models.json');
            if (response.ok) { // если HTTP-статус в диапазоне 200-299
                let json = await response.json();
                setModels(json);
            } else {
                alert("Ошибка HTTP: " + response.status);
            }
        };
        loadModelsJSON();
        setLanguage();
    },[]);

    const setLanguage = () => {
        let currentLanguage = window.location.href.slice(window.location.href.lastIndexOf('=') + 1);
        if (!currentLanguage || currentLanguage.length > 2) {
            currentLanguage = 'en';
        }
        console.log('LOCATION : ' + window.location.href + ' : ' + currentLanguage);
        i18n.changeLanguage(currentLanguage);
    };

    return (
        <I18nextProvider i18n={i18n}>
            {/*<button onClick={() => i18n.changeLanguage('ru')}>ru</button>
            <button onClick={() => i18n.changeLanguage('ua')}>ua</button>
            <button onClick={() => i18n.changeLanguage('en')}>en</button>*/}
            {
                (models.length > 0) ?
                    <Main models={models}/> : null
            }
        </I18nextProvider>
    )
}
export default withTranslation('common')(App);
